import { normalizeInternalReturnPath } from "./returnPath";

export function getAuthenticatedDestination(onboarding, requestedNext = null) {
  const completed =
    onboarding?.isComplete === true || onboarding?.status === "COMPLETED";
  if (!completed) {
    return "/onboarding";
  }
  return normalizeInternalReturnPath(requestedNext) || "/";
}
